/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';

import Alert from '../Alert';
import DesktopNavHeader from './lib/DesktopNavHeader';
import Header from '../Header';
import NavigationContainer from '../Navigation';
import PhoneNavHeader from './lib/PhoneNavHeader';
import UserNameAndIconContainer from '../UserNameAndIcon';

const Layout = ({ isPhone, isLoggedIn = false, isSidebarExpanded, children }) => {
  return (
    <div
      css={{
        position: 'relative',
        width: '100vw',
        height: '100%',
      }}
    >
      <aside
        css={{
          position: 'absolute',
          top: '0px',
          bottom: '0px',
          backgroundColor: '#00141C',
          width: isPhone ? '82vw' : 256,
          transition: isPhone ? 'left cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s' : 'left ease-in-out 0.3s',
          left: !isPhone ?
            0 :
            !isLoggedIn ?
              '-82vw' :
              isSidebarExpanded ?
                0 :
                '-82vw',
          zIndex: !isPhone ? 1 : 1000,
        }}
      >
        { !isPhone && <DesktopNavHeader /> }
        { isPhone && <PhoneNavHeader/> }
        <NavigationContainer />
        <UserNameAndIconContainer />
      </aside>
      <main
        css={{
          position: 'absolute',
          top: '0px',
          left: !isLoggedIn ?
            0 :
            isPhone ?
              0 :
              isSidebarExpanded ?
                256 :
                80,
          bottom: '0px',
          right: '0px',
          transition: 'left ease-in-out 0.3s',
          backgroundColor: isLoggedIn ? '#F0F2F5' : '#fff',
          zIndex: isPhone ? 1 : 1000,
        }}
      >
        <Header/>
        <div
          css={{
            position: 'absolute',
            top: '65px',
            left: '0px',
            bottom: '0px',
            right: '0px',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {children}
        </div>
      </main>
      <Alert />
    </div>
  );
};

export default Layout;
